import { Button } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";

export function GoogleLoginButton() {
  const { t } = useTranslation();
  const { loginWithGoogle } = useAuth();

  return (
    <Button
      variant="contained"
      fullWidth
      size="large"
      startIcon={<GoogleIcon />}
      onClick={loginWithGoogle}
      sx={{ py: 1.5, textTransform: "none", fontSize: 16, fontWeight: 600 }}
    >
      {t("auth.signInWithGoogle")}
    </Button>
  );
}
